export default __webpack_public_path__ + "static/media/hero.aa8ba5d2.svg";